import CoffeehouseShell from 'src/components/site/shells/CoffeehouseShell';
import { coffeehouseSiteRoutes } from 'src/config/sites/coffeehouseRoutes';
import { fetchCustomerData } from 'src/store/customer/data/actions';
import { fetchEntities } from 'src/store/entities/actions';
import { EntityDescriptions } from 'src/store/entities/types';
import { Projection } from 'src/store/entities/types/EntityDescription';
import { SiteDefinition } from './SiteDefinition';

const coffeehouseSite: SiteDefinition = {
    id: 'coffeehouse',
    label: 'Coffeehouse',
    description: 'Coffeehouse site — shop accessible to logged-in users, admin panel for admins only.',
    routes: coffeehouseSiteRoutes,
    shell: CoffeehouseShell,
    baseUrl: process.env.REACT_APP_COFFEEHOUSE_BASE_URL,
    productGroupSlugs: ['coffeeTimeTabs'],
    adminServiceEnabled: false,
    // TEMPORARY (2026-07-29): shows the Register button in the TopBar so the first
    // admin accounts can be created. Set back to false, drop the register route in
    // coffeehouseRoutes.tsx, and redeploy once they exist.
    registerEnabled: true,
    tabTitle: 'Coffeehouse',
    faviconUrl: '/coffeehouse-favicon.svg',
    init: ({ dispatch, runtime }) => {
        dispatch(fetchEntities(EntityDescriptions.PRODUCT_GROUP, Projection.NONE));
        if (runtime.isLoggedIn) {
            dispatch(fetchCustomerData());
        }
    },
};

export default coffeehouseSite;
